import Header24_morph_lg from './Header24_morph_lg'
export default Header24_morph_lg
